/**
 * Derive BuildTab visibility from publish flag and permissions (matches BuildTab slider logic).
 * @param {boolean} publishToCommunity
 * @param {object} permissions
 * @param {string|null|undefined} userTeamId
 * @returns {'private'|'team'|'organization'|'community'|'custom'}
 */
export function inferPromptVisibility(publishToCommunity, permissions, userTeamId) {
  if (publishToCommunity) return 'community';
  const p = permissions || {};
  const noAccess =
    !p.companyAccess &&
    (!p.teamAccess || p.teamAccess.length === 0) &&
    (!p.groupAccess || p.groupAccess.length === 0) &&
    (!p.individualAccess || p.individualAccess.length === 0);
  if (noAccess) return 'private';
  if (p.companyAccess) return 'organization';
  const singleTeam =
    p.teamAccess && p.teamAccess.length === 1 && p.teamAccess[0] === userTeamId;
  const viewOnly = Array.isArray(p.viewOnlyAccess) ? p.viewOnlyAccess : [];
  const canEdit = Array.isArray(p.canEdit) ? p.canEdit : [];
  const canDelete = Array.isArray(p.canDelete) ? p.canDelete : [];
  // Ignore the current team id in role arrays when it only duplicates teamAccess[0]
  // (legacy / post-migrate rows used to carry the team UUID in canEdit etc.).
  const meaningful = (ids) =>
    singleTeam && userTeamId ? ids.filter((id) => id !== userTeamId) : ids;
  const teamHasCustomRoles =
    userTeamId &&
    (meaningful(canEdit).length > 0 ||
      meaningful(canDelete).length > 0 ||
      meaningful(viewOnly).length > 0);
  if (singleTeam && !teamHasCustomRoles) return 'team';
  return 'custom';
}
